import { OkrSession } from "server/models"
import { TableGroupedIds, TableNestedIds } from "client/components"

export const GroupSessionsByParent = (sessions: OkrSession[]) => {
    const groupedByParent: { [parentSessionId: number]: OkrSession[] } = { 0: [] }
    sessions.forEach((session) => {
        if (session.sessionId === null) groupedByParent[0].push(session)
        else {
            if (!groupedByParent[session.sessionId]) groupedByParent[session.sessionId] = []
            groupedByParent[session.sessionId].push(session)
        }
    })
    return groupedByParent
}

export const GetSessionNested = (parentId: number, groupedByParent: { [parentSessionId: number]: OkrSession[] }) => {
    const nestedIds: TableNestedIds[] = []
    const childSessions = groupedByParent[parentId]
    if (childSessions) {
        childSessions.forEach((session) => {
            const nestedId: TableNestedIds = {
                id: session.id,
                nestedIds: GetSessionNested(session.id, groupedByParent),
            }
            nestedIds.push(nestedId)
        })

        // eslint-disable-next-line no-param-reassign
        delete groupedByParent[parentId] // remove used rows
    }
    return nestedIds
}

export const PrepareOkrSessionNestedIds = (sessions: OkrSession[]) => {
    const groupedByParent = GroupSessionsByParent(sessions)
    const nestedIds: TableNestedIds[] = []

    Object.keys(groupedByParent).forEach((key) => {
        const parentSessionId = key as unknown as number
        // continue if row was added to nested level
        if (!groupedByParent[parentSessionId]) return

        // all filtered sessions that were not added to nested levels will be added to the top level
        groupedByParent[parentSessionId].forEach((session) => {
            const nestedId: TableNestedIds = {
                id: session.id,
                nestedIds: GetSessionNested(session.id, groupedByParent),
            }
            nestedIds.push(nestedId)
        })
    })

    const grouped: TableGroupedIds[] = nestedIds.length
        ? [{
            groupId: null,
            nestedIds,
            nestedGroupedIds: [],
        }]
        : []
    return grouped
}
